// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Czge","newExpiryDate":"styles_newExpiryDate__29EME","footer":"styles_footer__19d7_"};